module.exports = __webpack_public_path__ + "static/img/fishGame3.cf83d61.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/head/fishGame3.png
// module id = 05pN
// module chunks = 3